export enum CampaignStatusStyle {
  InDesign = 'green-pill',
  Planned = 'yellow-pill',
  Open = 'w-primary-pill',
  Closed = 'white-pill',
  Blocked = 'red-pill',
}
